export default class journeyPlan {
  // 行程规划二期获取按钮权限配置
  // 接口文档：http://yapi.z-trip.cn/project/337/interface/api/17400
  static journeySwitch() {
    return window.$httpUtil.instance.get(`/api/bi/orderweb/journey/switch`)
  }
}
